export default class Username{
    constructor(value, type, userId){
        this.value = value;
        this.typeId = type;
        this.userId = userId || 0;
    }
}